import { Row } from 'antd'
import styled from 'styled-components'
import { IconBarChart } from '@edulastic/icons'
import { skippedBgColor, themeColor } from '@edulastic/colors'
import React from 'react'
import { Link } from 'react-router-dom'
import FeaturesSwitch from '../../../../../../../features/components/FeaturesSwitch'
import CardImage from './CardImage/cardImage'
import CardTextContent from './CardTextContent/cardTextContent'
import CardAssignmentContent from './CardAssignmentContent/cardAssignmentContent'

const CardBox = styled.div``
const CardFooter = styled.div`
  margin-top: 10px;
  height: 40px;
  background: ${skippedBgColor};
  padding: 10px 16px;
  border-radius: 0px 0px 10px 10px;

  p {
    margin-left: 6px;
  }
`

const ReportLink = styled(Link)`
  color: ${themeColor};
  text-decoration: none;
  font-weight: 600;
`

const Card = ({ data, userId, setClassType, activeClasses }) => (
  <CardBox data-cy={data.name}>
    <Row>
      <CardImage
        data={data}
        userId={userId}
        setClassType={setClassType}
        activeClasses={activeClasses}
      />
    </Row>
    <CardAssignmentContent data={data} userId={userId} />
    <Row>
      <CardTextContent data={data} userId={userId} />
    </Row>
    <FeaturesSwitch inputFeatures="profileReport">
      <CardFooter>
        <ReportLink to={`/author/reports/class-profile?classId=${data._id}`}>
          <Row type="flex" align="middle">
            <IconBarChart color={themeColor} /> <p>See Class Reports</p>
          </Row>
        </ReportLink>
      </CardFooter>
    </FeaturesSwitch>
  </CardBox>
)

export default Card
